import Enumerator from '../global/Enumerator';

export const contactPersonalReferenceRelationships = [
  'none',
  'friend',
  'partner',
  'financier_reference',
  'accountant',
  'employer',
  'contractor',
  'broker',
  'trade_reference'
];

export class ContactPersonalReferenceRelationship extends Enumerator {
  static default() {
    return this.of('none');
  }

  static of(option?: string) {
    let correctOption = option;
    switch (option) {
      case '1':
        correctOption = 'friend';
        break;
      case '2':
        correctOption = 'partner';
        break;
      case '3':
        correctOption = 'financier_reference';
        break;
      case '4':
        correctOption = 'accountant';
        break;
      case '5':
        correctOption = 'employer';
        break;
      case '6':
        correctOption = 'contractor';
        break;
      case '7':
        correctOption = 'broker';
        break;
      case '8':
        correctOption = 'trade_reference';
        break;
      default:
        break;
    }
    return this.enumValueOf(correctOption) || this.default();
  }
}

ContactPersonalReferenceRelationship.initEnum({
  none: {
    get title() {
      return 'Select one';
    }
  },
  friend: {
    get title() {
      return 'Friend';
    }
  },
  partner: {
    get title() {
      return 'Partner';
    }
  },
  financier_reference: {
    get title() {
      return 'Financier reference';
    }
  },
  accountant: {
    get title() {
      return 'Accountant';
    }
  },
  employer: {
    get title() {
      return 'Employer';
    }
  },
  contractor: {
    get title() {
      return 'Contractor';
    }
  },
  broker: {
    get title() {
      return 'Broker';
    }
  },
  trade_reference: {
    get title() {
      return 'Trade reference';
    }
  }
});

export default {
  contactPersonalReferenceRelationships,
  ContactPersonalReferenceRelationship
};
